import { Link } from 'react-router-dom'

interface ItemProps {
	image: string
	isActive: boolean
	link: string
	onClick?: () => void
	title: string
}

export function Item({ image, isActive, link, onClick, title }: ItemProps) {
	const className = `first-link text-list margin-top ${isActive ? 'active' : ''}`
	
	if (onClick) {
		return (
			<button className={className} onClick={onClick}>
				<div className="line-list__img-container">
					<img alt="pageIcon" src={image} />
				</div>
				{title}
			</button>
		)
	}

	return (
		<Link className={className} to={link}>
			<div className="line-list__img-container">
				<img alt="pageIcon" src={image} />
			</div>
			{title}
		</Link>
	)
}
